import React from "react";
import { useSection } from "../../i18n/useSection";

export default function AuthTerms({ signup = false }) {
  const t = useSection("mmtAuth");
  return (
    <p className="mmt-auth-terms">
      {signup ? t.signup_terms : t.login_terms}{" "}
      <a
        href="https://seniorlife.ai/terms-of-service/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t.terms}
      </a>{" "}
      {t.and}{" "}
      <a
        href="https://seniorlife.ai/privacy-data-policy/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t.privacy}
      </a>
      {t.terms_end}
    </p>
  );
}
